import animateScrollTo from "animated-scroll-to";

/**
 * @param {HTMLElement} button
 */
export default function initializeScrollButton(button) {
  const main = document.querySelector('main');

  if (main.children[2] === undefined) {
    return;
  }

  button.addEventListener('click', () => {

    animateScrollTo(main.children[2])
      .then();
  });
}
